var radiansToDegrees = function radiansToDegrees(radians) {
  return radians * 180 / Math.PI;
};
export { radiansToDegrees };